import { EXTENSION_TO_MIME } from '@constants/notesAttachment';

const getSupportedFileTypes = extensions => {
  return extensions.reduce((acc, ext) => {
    const normalizedExt = ext.toLowerCase();
    const mime = EXTENSION_TO_MIME[normalizedExt];

    if (!mime) {
      return acc; // silently ignore unsupported types (e.g. xml)
    }

    if (!acc[mime]) {
      acc[mime] = [];
    }

    acc[mime].push(`.${normalizedExt}`);
    return acc;
  }, {});
};

export default getSupportedFileTypes;
